import http from "../../utils/fetch";

export default {

    baseurl:'/api/swyl/v1/reform/bscSpecificCatalogue',

    selecPage(query) {
        return http({
            url: this.baseurl+'/selectPage',
            method: 'post',
            params: query
        });
    },
    selectByOneLId(query) {
        return http({
            url: this.baseurl+'/selectByOneLId',
            method: 'post',
            params: query
        });
    },
    selectAllDivision(query) {
        return http({
            url: this.baseurl+'/selectAllDivision',
            method: 'post',
            params: query
        });
    },
    selectAllOne(query){
        return http({
            url: this.baseurl+'/selectAllOne',
            method: 'post',
            params: query
        });

    },


    insert(f){
        return http({
            url: this.baseurl+'/insert',
            method: 'post',
            params: f
        });
    },
}